import React from 'react';

import { GoogleCalendarIcon } from '@atlassian/rovo-platform-ui-components/google-calendar-icon';

export const GoogleCalendarIconBorderless = (): React.JSX.Element => (
	<GoogleCalendarIcon size={16} />
);
